import { useRouter } from "next/router";

const useGetUrlQueryParameters = () => {
  const router = useRouter();
  const { query } = router;

  return query || null;
};

export default useGetUrlQueryParameters;
